const Healthcheck = () => {
  return <>healthcheck_ok</>
}

export default Healthcheck
